import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, SpinnerLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import BillingAddressForm from "~/components/Subscription/BillingPaymentMethod/BillingAddressForm";

const AddBillingAddressDialog = ({ open, onClose }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const startLoader = useCallback(() => {
    setTimeout(() => {
      setIsLoading(true);
    }, 0);
  }, []);

  const onError = useCallback(() => {
    setIsLoading(false);
  }, []);

  const isValidated = useCallback((e) => {
    setIsValid(e);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <Dialog.Title data-testid="dialogTitle">{t("Change Billing Details")}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content data-testid="dialogContent">
        <div data-testid="billingAddressForm">
          <BillingAddressForm
            onSubmit={onClose}
            onError={onError}
            isValidated={isValidated}
          />
        </div>
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions
        data-testid="dialogActions"
        className="tw-flex tw-flex-col md:tw-flex-row tw-gap-3"
      >
        {!isLoading ? (
          <>
            <Button
              variant="primary"
              className="tw-mr-3"
              type="submit"
              form="billing_address_form"
              onClick={startLoader}
              disabled={!isValid}
              data-testid="submitButton"
            >
              {t("Change Billing Details")}
            </Button>
            <Button
              variant="secondary"
              data-action="cancel"
              onClick={onClose}
              data-testid="cancelButton"
            >
              {t("Cancel")}
            </Button>
          </>
        ) : (
          <div
            className="tw-flex"
            data-testid="spinnerDiv"
          >
            <SpinnerLoader />
            <span className="tw-ml-2">{t("Updating billing details ...")}</span>
          </div>
        )}
      </Dialog.Actions>
    </Dialog>
  );
};

AddBillingAddressDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default AddBillingAddressDialog;
